// Centralized level calculation system
// Thresholds: 500, 1000, 2000, 5000 XP for each level

const LEVEL_CONFIG = [
    { level: 1, title: 'Beginner', icon: '🌱', minXP: 0, maxXP: 499 },
    { level: 2, title: 'Learner', icon: '📚', minXP: 500, maxXP: 999 },
    { level: 3, title: 'Student', icon: '🎓', minXP: 1000, maxXP: 1999 },
    { level: 4, title: 'Scholar', icon: '👨‍🎓', minXP: 2000, maxXP: 4999 },
    { level: 5, title: 'Master', icon: '🏆', minXP: 5000, maxXP: Infinity }
];

export const getLevel = (xp = 0) => {
    const totalXP = Math.max(0, xp);

    for (let i = LEVEL_CONFIG.length - 1; i >= 0; i--) {
        if (totalXP >= LEVEL_CONFIG[i].minXP) {
            const config = LEVEL_CONFIG[i];
            const nextLevel = LEVEL_CONFIG[i + 1];

            return {
                level: config.level,
                title: config.title,
                icon: config.icon,
                currentXP: totalXP,
                minXP: config.minXP,
                maxXP: config.maxXP,
                nextLevelXP: nextLevel ? nextLevel.minXP : null,
                xpInLevel: totalXP - config.minXP,
                xpNeededForLevel: nextLevel ? nextLevel.minXP - config.minXP : 0,
                progress: nextLevel
                    ? ((totalXP - config.minXP) / (nextLevel.minXP - config.minXP)) * 100
                    : 100,
                isMaxLevel: !nextLevel
            };
        }
    }

    // Fallback to level 1
    return {
        level: 1,
        title: 'Beginner',
        icon: '🌱',
        currentXP: totalXP,
        minXP: 0,
        maxXP: 499,
        nextLevelXP: 500,
        xpInLevel: totalXP,
        xpNeededForLevel: 500,
        progress: (totalXP / 500) * 100,
        isMaxLevel: false
    };
};

export const LEVEL_THRESHOLDS = [0, 500, 1000, 2000, 5000];

export default getLevel;
